// extracted by mini-css-extract-plugin
export default {"saveButtonWrapper":"SaveButton_saveButtonWrapper__sGta3"};